// authTokenStorage.ts
//
// Companion (external-auth) token storage. The Auth0 refresh token is NEVER
// stored client-side under the Token-Mediating Backend model — the backend owns
// it. The companion holds only the short-lived access token and an opaque,
// server-revocable session handle it presents to refresh.

export const ACCESS_TOKEN_KEY = 'access_token';
export const SESSION_HANDLE_KEY = 'companion_session_handle';

export const authTokenStorage = {
  set(token: string) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  },

  get(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },

  setSessionHandle(handle: string) {
    localStorage.setItem(SESSION_HANDLE_KEY, handle);
  },

  getSessionHandle(): string | null {
    return localStorage.getItem(SESSION_HANDLE_KEY);
  },

  clear() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(SESSION_HANDLE_KEY);
  },
};
